/* Carga diferida de klaviyo.js (PM-55): el script de Klaviyo se pide cuando la página ya
   terminó de cargar, en vez de en el <head> como lo inyecta el app embed. Replica lo que el
   embed hacía además de cargar el script: la cola del objeto `klaviyo` y, en producto, el
   evento "Viewed Product". Datos de entrada (los pone snippets/klaviyo-onsite.liquid):
   window.KLAVIYO_COMPANY_ID (ajuste del theme; vacío = no se carga nada) y
   window.KLAVIYO_VIEWED (solo en producto). Si el app embed sigue encendido no hace nada:
   el embed ya carga el script y manda Viewed Product. */
(function () {
  var id = window.KLAVIYO_COMPANY_ID;
  if (!id) return;
  if (document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) return; // el app embed sigue encendido: él carga el script y manda Viewed Product

  if (!window.klaviyo) {
    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy({}, {
        get: function (_, metodo) {
          if (metodo === "push") return function () { var q = window._klOnsite; q.push.apply(q, arguments); };
          return function () {
            var args = Array.prototype.slice.call(arguments);
            var cb = typeof args[args.length - 1] === "function" ? args.pop() : undefined;
            return new Promise(function (resolver) {
              window._klOnsite.push([metodo].concat(args, [function (r) { if (cb) cb(r); resolver(r); }]));
            });
          };
        }
      });
    } catch (e) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = function () { var q = window._klOnsite; q.push.apply(q, arguments); };
    }
  }

  var item = window.KLAVIYO_VIEWED;
  if (item && item.ProductID) {
    window._learnq = window._learnq || [];
    window._learnq.push(["track", "Viewed Product", item]);
    window._learnq.push(["trackViewedItem", {
      Title: item.Name, ItemId: item.ProductID, Categories: item.Categories, ImageUrl: item.ImageURL, Url: item.URL,
      Metadata: { Brand: item.Brand, Price: item.Price, Value: item.Value, CompareAtPrice: item.CompareAtPrice }
    }]);
  }

  function carga() {
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://static.klaviyo.com/onsite/js/" + encodeURIComponent(id) + "/klaviyo.js?company_id=" + encodeURIComponent(id);
    document.head.appendChild(s);
  }
  if (document.readyState === "complete") carga(); else window.addEventListener("load", carga);
})();
